// src/pages/Login.js

import { Helmet } from 'react-helmet'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form'
import { useNavigate } from 'react-router-dom';

import { useState } from "react"

import { login, verify } from '../Utils/Authentication'

export default function Login( props ) {
    const destination = props.to
    //const { loginLoading, loginError } = useAuthState()
    //const { login, clearLoginError } = useAuthActions()

    // Clear login error when Login component unmount
    //useEffect(() => () => clearLoginError(), [clearLoginError])

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [hasError, setHasError] = useState(false)

    let navigate = useNavigate()

    return (
        <div  style={{ height:"calc( 100vh - 60px )" }}>
            <Helmet>
                <title>Manager | Login</title>
            </Helmet>

            <div className="d-flex justify-content-center" style={{ height:"100%", paddingTop: "100px" }}>
                <Container fluid>
                    <center>
                    <Row>
                        <div>
                        <h1>Clinic Manager</h1>
                        </div>
                    </Row>
                    <div style={{ width:"500px"}}>
                       <Form.Group className="mb-3">
                            <Form.Control
                                    type="text"
                                    placeholder="Username"
                                    value={username}
                                    onChange={ e => {
                                        setHasError( false )
                                        setUsername( e.target.value )
                                    }}
                                    style={{ marginBottom:"10px" }}
                                />
                            <Form.Control
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={ e => {
                                        setHasError( false )
                                        setPassword( e.target.value )
                                    }}
                                />
                        
                            </Form.Group>
                            <Button variant="secondary" 
                                    //disabled={loginLoading}
                                    style={{ width:"175px" }}
                                    onClick={ e => {
                                        e.preventDefault()
                                        if( username !== "" && password !== "" )
                                        {
                                            login( { username, password }).then( res => {
                                                if( res )
                                                {
                                                    setHasError( false )
                                                    navigate(destination)
                                                }
                                                else
                                                {
                                                    setHasError( true )
                                                } 
                                            })
                                        }
                                    }}
                                >
                                    Login
                            </Button>
                        </div>
                    </center>
                </Container>
            </div>
        </div>
    )
}
